import axios from './biAxios';
import authHeader from "./authentification-header";

const API_URL = "/api/usertransport/";

const getUserTransportList = (userId) => axios
    .get(`${API_URL}getusertransportlist?userId=${userId ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const saveUserTransport = (list) => axios
    .post(`${API_URL}saveusertransport`, list, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const removeUserTransport = (userId) => axios
    .post(`${API_URL}removeusertransport?userId=${userId ?? ''}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const saveUser = (role, team, transport, user) => axios
    .post(`${API_URL}saveuser`, { role, team, transport: transport ?? [], user }, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const deleteUser = (useId) => axios
    .post(`${API_URL}removeuser/${useId ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));

const allActions = {
    getUserTransportList,
    saveUserTransport,
    removeUserTransport,
    saveUser,
    deleteUser,
};

export default allActions;